exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".publish-board img{border-radius:10px;height:200px;width:200px;box-shadow:0 0 34px 0 rgba(0,0,0,.15)}.publish-board a,.publish-board a:focus,.publish-board a:hover,.publish-board a:visited{color:#0c2d39}.publish-board a.change,.publish-board a.change:focus,.publish-board a.change:hover,.publish-board a.change:visited{color:#009487}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54634a57","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Board/Publish.vue
// module id = 428
// module chunks = 0